export const coordinateKey = (longitude, latitude, precision = 5) => {
  if (longitude === null || longitude === undefined || latitude === null || latitude === undefined) return null
  if (!Number.isFinite(Number(longitude)) || !Number.isFinite(Number(latitude))) return null

  return `${Number(longitude).toFixed(precision)},${Number(latitude).toFixed(precision)}`
}

export const recordCoordinateKey = (record, precision = 5) => coordinateKey(record?.longitude, record?.latitude, precision)

export const visibleMarkerParcels = ({ layerMode, opportunities, parcels, precision = 5 }) => {
  if (layerMode !== 'all') return parcels

  const opportunityKeys = new Set(opportunities.map((point) => recordCoordinateKey(point, precision)).filter(Boolean))

  return parcels.filter((parcel) => !opportunityKeys.has(recordCoordinateKey(parcel, precision)))
}

export const operatorSlug = (value) => String(value || '')
  .toLowerCase()
  .replace(/&/g, ' and ')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-+|-+$/g, '')
  .slice(0, 80)

export const operatorInitials = (value) => {
  const words = String(value || '')
    .replace(/&/g, ' and ')
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)

  if (words.length === 0) return 'DC'

  return words.slice(0, 2).map((word) => word[0].toUpperCase()).join('')
}

export const isAbortError = (error) => error?.name === 'AbortError'
